/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListBazaarItems200ResponseLinks
 */
export interface ListBazaarItems200ResponseLinks {
    /**
     * 
     * @type {string}
     * @memberof ListBazaarItems200ResponseLinks
     */
    first?: string;
    /**
     * 
     * @type {string}
     * @memberof ListBazaarItems200ResponseLinks
     */
    last?: string;
    /**
     * 
     * @type {string}
     * @memberof ListBazaarItems200ResponseLinks
     */
    prev?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListBazaarItems200ResponseLinks
     */
    next?: string | null;
}

/**
 * Check if a given object implements the ListBazaarItems200ResponseLinks interface.
 */
export function instanceOfListBazaarItems200ResponseLinks(value: object): value is ListBazaarItems200ResponseLinks {
    return true;
}

export function ListBazaarItems200ResponseLinksFromJSON(json: any): ListBazaarItems200ResponseLinks {
    return ListBazaarItems200ResponseLinksFromJSONTyped(json, false);
}

export function ListBazaarItems200ResponseLinksFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListBazaarItems200ResponseLinks {
    if (json == null) {
        return json;
    }
    return {
        
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'prev': json['prev'] == null ? undefined : json['prev'],
        'next': json['next'] == null ? undefined : json['next'],
    };
}

export function ListBazaarItems200ResponseLinksToJSON(json: any): ListBazaarItems200ResponseLinks {
    return ListBazaarItems200ResponseLinksToJSONTyped(json, false);
}

export function ListBazaarItems200ResponseLinksToJSONTyped(value?: ListBazaarItems200ResponseLinks | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first': value['first'],
        'last': value['last'],
        'prev': value['prev'],
        'next': value['next'],
    };
}

